import teamplate from './index.jst';
import { CoreRankingsRow } from '../../../views';
import './index.styl';
import { User } from '../../../models';

/**
 * @desc Rankings Comps Row Class
 * This class using on rankings page ('rankings/comp')
 */
export class RankingsRowComp extends CoreRankingsRow {
	get template () {
		return teamplate;
	}

	initialize() {
		let current_round    = this.getOption( 'current_round' );

		this.model
			.setAvatar()
			.setDifferentPoints(  )
			.set({
				current_round,
				current_user_id: User.get( 'id' )
			});
	}
}

export default RankingsRowComp;